import Elevation from "./Elevation";

export default class RelativeElevation extends Elevation {
  static getLabel() {
    return "Relative Elevation";
  }
}
